import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, ArrowRight, Lock } from 'lucide-react';
export function PurchaseSection() {
  const features = ['Acceso inmediato a todo el sistema', 'Manuales, actividades y correcciones', 'Bonos exclusivos incluidos', 'Actualizaciones futuras gratis', 'Material 100% editable y personalizable', 'Soporte prioritario por email'];
  return <section id="purchase" className="py-16 bg-gray-900 text-white relative overflow-hidden" data-id="element-108">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-109">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-600 rounded-full filter blur-[128px] opacity-20" data-id="element-110"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-purple-600 rounded-full filter blur-[128px] opacity-20" data-id="element-111"></div>
      </div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-112">
        <div className="text-center mb-12" data-id="element-113">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-114">
            Recuperá tu tiempo y tu tranquilidad hoy mismo
          </h2>
          <p className="text-xl text-gray-300" data-id="element-115">
            Todo lo que necesitás para dar clases increíbles sin quemarte, en un
            solo lugar.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white text-gray-900 rounded-3xl shadow-2xl overflow-hidden max-w-lg mx-auto" data-id="element-116">
          <div className="bg-blue-600 p-4 text-center text-white font-bold tracking-wider text-sm" data-id="element-117">
            OFERTA LIMITADA - DESCARGA INMEDIATA
          </div>

          <div className="p-8 md:p-12" data-id="element-118">
            <div className="text-center mb-8" data-id="element-119">
              <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-120">
                PACK INGLÉS LISTO™
              </h3>
              <p className="text-gray-500 mb-6" data-id="element-121">Edición Completa + Bonos</p>

              <div className="flex items-center justify-center gap-3 mb-2" data-id="element-122">
                <span className="text-gray-400 line-through text-xl" data-id="element-123">
                  $45.000
                </span>
                <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm font-bold" data-id="element-124">
                  AHORRÁS 55%
                </span>
              </div>
              <div className="text-5xl font-extrabold text-gray-900 mb-2" data-id="element-125">
                $19.990{' '}
                <span className="text-xl font-medium text-gray-500" data-id="element-126">ARS</span>
              </div>
              <p className="text-sm text-gray-500" data-id="element-127">
                Pago único. Acceso de por vida.
              </p>
            </div>

            <ul className="space-y-4 mb-10" data-id="element-128">
              {features.map((feature, i) => <li key={i} className="flex items-center gap-3" data-id="element-129">
                  <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-130" />
                  <span className="text-gray-700" data-id="element-131">{feature}</span>
                </li>)}
            </ul>

            <a href="https://checkout.ebookify.online/cart/53387992334620:1" target="_blank" rel="noopener noreferrer" className="block w-full group" data-id="element-132">
              <button className="w-full bg-red-600 hover:bg-red-700 text-white font-bold py-5 px-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center gap-3 text-xl transform group-hover:scale-[1.02]" data-id="element-133">
                <span data-id="element-134">DESCARGAR AHORA</span>
                <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-135" />
              </button>
            </a>

            <div className="mt-6 flex items-center justify-center gap-2 text-gray-400 text-sm" data-id="element-136">
              <Lock className="w-4 h-4" data-id="element-137" />
              <span data-id="element-138">Pago 100% Seguro y Encriptado</span>
            </div>
          </div>

          <div className="bg-gray-50 p-6 text-center border-t border-gray-100" data-id="element-139">
            <p className="text-gray-600 font-medium mb-2" data-id="element-140">
              PACK INGLÉS LISTO™ te devuelve:
            </p>
            <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-sm text-gray-500" data-id="element-141">
              <span data-id="element-142">✔ Tiempo</span>
              <span data-id="element-143">✔ Control</span>
              <span data-id="element-144">✔ Tranquilidad</span>
              <span data-id="element-145">✔ Seguridad</span>
              <span data-id="element-146">✔ Energía</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}